import { jsxs as i, Fragment as l, jsx as o } from "react/jsx-runtime";
import n from "./components/icon/Icon.js";
import "classnames";
import { ButtonLoadingIndicator as r } from "./components/button/ButtonLoadingIndicator.js";
import './assets/ButtonLinkBase.css';const j = "_link_j4ojh_9", c = "_button_j4ojh_9", d = "_loading_j4ojh_19", m = "_loader_j4ojh_22", h = "_disabled_j4ojh_50", u = "_fullwidth_j4ojh_83", y = "_active_j4ojh_99", p = "_text_j4ojh_113", b = "_small_j4ojh_117", f = "_medium_j4ojh_124", x = "_large_j4ojh_131", g = "_primary_j4ojh_138", v = "_secondary_j4ojh_147", w = "_tertiary_j4ojh_157", k = "_layered_j4ojh_170", B = "_inline_j4ojh_179", L = "_destructive_j4ojh_194", s = {
  link: j,
  button: c,
  loading: d,
  loader: m,
  disabled: h,
  fullwidth: u,
  "fullwidth-mobile": "_fullwidth-mobile_j4ojh_83",
  active: y,
  text: p,
  small: b,
  medium: f,
  large: x,
  primary: g,
  secondary: v,
  tertiary: w,
  layered: k,
  inline: B,
  destructive: L,
  "secondary-on-accent": "_secondary-on-accent_j4ojh_200"
}, A = ({ children: t, trailingIcon: _, leadingIcon: e, loading: a }) => /* @__PURE__ */ i(l, { children: [
  a && /* @__PURE__ */ o(r, { className: s.loader }),
  !!e && /* @__PURE__ */ o(n, { name: e }),
  !!t && /* @__PURE__ */ o("span", { className: s.text, children: t }),
  !!_ && /* @__PURE__ */ o(n, { name: _ })
] });
export {
  A as B,
  s
};
